var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center text-white text-lg uppercase px-10 py-3 border rounded-small font-bold done-button flex items-center shadow-lg relative cursor-pointer",class:{
    disabled: _vm.disabled,
    main: _vm.type === 'main',
    adminMain: _vm.type === 'adminMain',
    secondary: _vm.type === 'secondary',
    smallButton: _vm.size === 'small'
  }},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('l-loading-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }